var _rect, _path, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIBoxen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#e8e1d7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 62.5 H437.5 V437.5 H62.5 V401.5 H401.5 V98.5 H101.5 V152.5 H62.5 V62.5 Z",
    fill: "#004d57"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 179.5,
    width: 39,
    height: 39,
    fill: "#004d57"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 244.5,
    width: 39,
    height: 121,
    fill: "#004d57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 250) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -130,
    y: -35,
    width: 260,
    height: 70,
    fill: "#004d57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -130,
    width: 70,
    height: 260,
    fill: "#f75a7c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBoxen);
export default __webpack_public_path__ + "static/media/IBoxen.4a411288cb35d573220f3ed0c7f18c05.svg";
export { ForwardRef as ReactComponent };